/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Google_Missing_Id_TokenInputs */

const en_mobile_google_missing_id_token = /** @type {(inputs: Mobile_Google_Missing_Id_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google did not return an ID token`)
};

const es_mobile_google_missing_id_token = /** @type {(inputs: Mobile_Google_Missing_Id_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google no devolvió un token de ID`)
};

/**
* | output |
* | --- |
* | "Google did not return an ID token" |
*
* @param {Mobile_Google_Missing_Id_TokenInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_google_missing_id_token = /** @type {((inputs?: Mobile_Google_Missing_Id_TokenInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Google_Missing_Id_TokenInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_google_missing_id_token(inputs)
	return en_mobile_google_missing_id_token(inputs)
});